import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

/**
 * Ruta `daviplata/download/:transactionId` — punto de entrada para descarga;
 * puede ampliarse con la lógica de negocio que necesiten.
 */
@Component({
  selector: 'app-daviplata-download-voucher',
  standalone: true,
  imports: [CommonModule, RouterLink, MatButtonModule],
  template: `
    <div class="wrap">
      <p>Descarga de comprobante Daviplata</p>
      @if (transactionId) {
        <p class="muted">Operación: {{ transactionId }}</p>
      }
      <a mat-raised-button color="primary" [routerLink]="['/daviplata/form', transactionId || '0']">
        Volver al formulario
      </a>
    </div>
  `,
  styles: [
    `
      .wrap {
        padding: 24px;
        text-align: center;
      }
      .muted {
        color: #666;
        font-size: 14px;
      }
    `,
  ],
})
export class DownloadVoucherComponent {
  transactionId: string | null = null;

  constructor(private route: ActivatedRoute) {
    this.route.paramMap.subscribe((p) => {
      this.transactionId = p.get('transactionId');
    });
  }
}
